import { Colors, Fonts } from "@/theme";
import styled from "styled-components";
import { MaxWidthContainer } from "../styles";
import { mobile } from "@/theme/common";

/**
 * Types
 */
interface WhoCanPlaySectionProps {
  title: string;
  subtitle: string;
}

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${Colors.blackPurple};
  width: 100%;
  padding: 32px;
`;

const Title = styled.h2`
  color: white;
  font-size: 20px;
  line-height: 28px;
  font-family: ${Fonts.ttNormsProBold};
  margin: 0;
  text-align: center;
  ${mobile(`
    text-align: left;
  `)}
`;

const Subtitle = styled.p`
  color: white;
  font-size: 16px;
  line-height: 24px;
  font-family: ${Fonts.ttNormsProNormal};
  margin: 0;
  text-align: center;
  ${mobile(`
    text-align: left;
  `)}
`;

/**
 * WhoCanPlaySection Component
 */

export const WhoCanPlaySection = ({
  title,
  subtitle,
}: WhoCanPlaySectionProps) => {
  return (
    <Container>
      <MaxWidthContainer>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
      </MaxWidthContainer>
    </Container>
  );
};
